module.exports = __webpack_public_path__ + "img/tipicon-finanzas.f8fef7de.svg";